$('[name=selectedWinner]').on('change', async function() {
    let winner = $(this).is(':checked');
    $(this).closest('.card').find('.prize-group').toggleClass('d-none', !winner);
});

$('[name=selectedWinner], [name=selectedPrize]').on('change', async function() {
    let form = $(this).closest('form')[0];
    try {
        let data = await $.ajax({
            type: 'post',
            url: form.action,
            data: new FormData(form),
            processData: false,
            contentType: false,
        });
        location.reload();
    } catch (xhr) {
        if (xhr.status == 409) {
            location.reload();
        } else {
            alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
        }
    }
    /*$('.winners-selection-prize-counter span').each(function() {
        $(this).text(data.usedPrizes[$(this).data('prize')] || 0);
    });*/
});